import { FC, useContext } from 'react';

import { ShopIcon, XReportIcon } from '@smartshell/ui-kit';

import { ReportSummaryBlock } from 'components';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { formatMoney, useSummaryValues } from '../utils';
import s from './GoodsSummary.module.scss';
import { IGoodsSummaryProps } from './interfaces';

export const GoodsSummary: FC<IGoodsSummaryProps> = ({ data, loading }) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);
  const { getValue } = useSummaryValues(data, loading);

  const normalizedData = [
    {
      text: t('sold.goods'),
      value: `${formatMoney(getValue('total_goods_sold'))}${t('pcs')}`,
      icon: <ShopIcon color="secondary" />,
    },
    {
      text: t('middle.check.goods'),
      value: `${formatMoney(getValue('avg_goods_receipt'), currency.sign)}`,
      icon: <XReportIcon color="secondary" />,
    },
  ];

  return (
    <div className={s.container}>
      {normalizedData.map((item) => (
        <ReportSummaryBlock key={item.text} item={item} />
      ))}
    </div>
  );
};
